module.exports = __webpack_public_path__ + "img/rejectedGreen.e63b09ac.png";